module.exports = __webpack_public_path__ + "static/media/umbraco.e9cc0827.svg";